angular.module('mtic').constant('DEV_VARIABLES', {
  GROUPS: {
    LUXEMBOURG: {
      TEACHERLESS_MODULES: [
        {resource_type:'mtic_c3_m_meta', group_id: 2018},
        {resource_type:'c4_meta_module', group_id: 2019},
        {resource_type:'mtic_gr78_m_meta', group_id: 1917},
        {resource_type:'mtic_vp', group_id: 8748}
      ],
      AVAILABLE_MODULES: [
        {resource_id: 317, module_id: 11,    foreign_slug: 'lux_ef_c3'},
        {resource_id: 385, module_id: 28,    foreign_slug: 'lux_ef_c4'},
        {resource_id: 99, module_id: 2,     foreign_slug: 'lux_es_ci'},
        {resource_id: 6246, module_id: 1234,  foreign_slug: 'lux_es_mod'},
        {resource_id: 6098, module_id: 1234,  foreign_slug: 'lux_es_mod'},
      ]
    }
  },
  RESOURCES: {
    HIDE_THESE: [
      'mtic_g78_m1_prop_table_b',
      'mtic_g78_m1_beaker',
      'mtic_g78_m3_graph_area',

      /* gr78_m4 */
      // 'mtic_g78_m4_conv_b',
      // 'mtic_g78_m4_conv_dec',
      // 'mtic_g78_m4_conv_frac',
      // 'mtic_g78_m4_div_b',
      // 'mtic_g78_m4_verify_figure',
      // 'mtic_g78_m4_reproduire_partie_1',
      // 'mtic_g78_m4_reproduire_partie_2',
      // 'mtic_g78_m4_slushie_pt2',
      // 'mtic_g78_m4_slushie_pt1',
      // 'mtic_g78_m4_dominos',
      // 'mtic_g78_m4_triominos_pt1',
      // 'mtic_g78_m4_triominos_pt2',
      // 'mtic_g78_m4_sub_b',
      // 'mtic_g78_m4_order',
      // 'mtic_g78_m4_div_pt2_a',
      // 'mtic_g78_m4_mult_a_pt2',
      // 'mtic_g78_m4_divisibility_b',
      // 'mtic_g78_m4_carrot',
      // 'mtic_g78_m4_determine_figure',
      // 'mtic_g78_m4_comp_b',
      // 'mtic_g78_m4_equiv_b',
      // 'mtic_g78_m4_mahjong',
      // 'mtic_g78_m4_add_b',
      // 'mtic_g78_m4_mult_b_pt1',
      // 'mtic_g78_m4_bedmas_a',
      // 'mtic_g78_m4_mult_b_pt2',
      // 'mtic_g78_m4_div_pt1_a',
      // 'mtic_g78_m4_mult_a_pt3',
      // 'mtic_g78_m4_attack_puz',
      // 'mtic_g78_m4_bedmas_b',
      // 'mtic_g78_m4_attack_time',
      // 'mtic_g78_m4_num_line_b',
      // 'mtic_g78_m4_diagnostic',
      // 'mtic_g78_m4_mult_a_pt1',
    ],
    LOCK_THESE: [
      //'mtic_gr78_m4',

      /* gr78_m4 */
      // 'mtic_g78_m4_conv_b',
      // 'mtic_g78_m4_conv_dec',
      // 'mtic_g78_m4_conv_frac',
      // 'mtic_g78_m4_div_b',
      // 'mtic_g78_m4_verify_figure',
      // 'mtic_g78_m4_reproduire_partie_1',
      // 'mtic_g78_m4_reproduire_partie_2',
      // 'mtic_g78_m4_slushie_pt2',
      // 'mtic_g78_m4_slushie_pt1',
      // 'mtic_g78_m4_dominos',
      // 'mtic_g78_m4_triominos_pt1',
      // 'mtic_g78_m4_triominos_pt2',
      // 'mtic_g78_m4_sub_b',
      // 'mtic_g78_m4_order',
      // 'mtic_g78_m4_div_pt2_a',
      // 'mtic_g78_m4_mult_a_pt2',
      // 'mtic_g78_m4_divisibility_b',
      // 'mtic_g78_m4_carrot',
      // 'mtic_g78_m4_determine_figure',
      // 'mtic_g78_m4_comp_b',
      // 'mtic_g78_m4_equiv_b',
      // 'mtic_g78_m4_mahjong',
      // 'mtic_g78_m4_add_b',
      // 'mtic_g78_m4_mult_b_pt1',
      // 'mtic_g78_m4_bedmas_a',
      // 'mtic_g78_m4_mult_b_pt2',
      // 'mtic_g78_m4_div_pt1_a',
      // 'mtic_g78_m4_mult_a_pt3',
      // 'mtic_g78_m4_attack_puz',
      // 'mtic_g78_m4_bedmas_b',
      // 'mtic_g78_m4_attack_time',
      // 'mtic_g78_m4_num_line_b',
      // 'mtic_g78_m4_diagnostic',
      // 'mtic_g78_m4_mult_a_pt1',
    ],
    MARK_COMPLETE: [

    ],
    UNLOCK_THESE: [
      
      //gr78_m4
      // 'mtic_g78_m4_multiple',
      // 'mtic_g78_m4_divisibility_a_pt1',
      // 'mtic_g78_m4_divisibility_a_pt2',
      // 'mtic_g78_m4_divisors',
      // 'mtic_g78_m4_intro_frac',
      // 'mtic_g78_m4_num_line_a',
      // 'mtic_g78_m4_equiv_a',
      // 'mtic_g78_m4_simp',
      // 'mtic_g78_m4_comp_a',
      // 'mtic_g78_m4_add_same',
      // 'mtic_g78_m4_add_diff',
      // 'mtic_g78_m4_sub_a',
      // 'mtic_g78_m4_multi_tutorial',
      // 'mtic_g78_m4_conv_b',
      // 'mtic_g78_m4_conv_dec',
      // 'mtic_g78_m4_conv_frac',
      // 'mtic_g78_m4_div_b',
      // 'mtic_g78_m4_verify_figure',
      // 'mtic_g78_m4_reproduire_partie_1',
      // 'mtic_g78_m4_reproduire_partie_2',
      // 'mtic_g78_m4_slushie_pt2',
      // 'mtic_g78_m4_slushie_pt1',
      // 'mtic_g78_m4_dominos',
      // 'mtic_g78_m4_triominos_pt1',
      // 'mtic_g78_m4_triominos_pt2',
      // 'mtic_g78_m4_sub_b',
      // 'mtic_g78_m4_order',
      // 'mtic_g78_m4_div_pt2_a',
      // 'mtic_g78_m4_mult_a_pt2',
      // 'mtic_g78_m4_divisibility_b',
      // 'mtic_g78_m4_carrot',
      // 'mtic_g78_m4_determine_figure',
      // 'mtic_g78_m4_comp_b',
      // 'mtic_g78_m4_equiv_b',
      // 'mtic_g78_m4_mahjong',
      // 'mtic_g78_m4_add_b',
      // 'mtic_g78_m4_mult_b_pt1',
      // 'mtic_g78_m4_bedmas_a',
      // 'mtic_g78_m4_mult_b_pt2',
      // 'mtic_g78_m4_div_pt1_a',
      // 'mtic_g78_m4_mult_a_pt3',
      // 'mtic_g78_m4_attack_puz',
      // 'mtic_g78_m4_bedmas_b',
      // 'mtic_g78_m4_attack_time',
      // 'mtic_g78_m4_num_line_b',
      // 'mtic_g78_m4_diagnostic',
      // 'mtic_g78_m4_mult_a_pt1',

      //gr78-m3 items
      // "mtic_g78_m3_game_sub_pt1",
      //"mtic_g78_m3_diag",
      // "mtic_g78_m3_game_sub_pt2","mtic_g78_m3_graph_perim","mtic_g78_m3_inver_oper","mtic_g78_m3_inver_oper_pt2","mtic_g78_m3_alg_balance","mtic_g78_m3_graph_area","mtic_g78_m3_class_eq","mtic_g78_m3_sub_method","mtic_g78_m3_bracket_wo","mtic_g78_m3_bracket_wo_pt2","mtic_g78_m3_bracket_incl","mtic_g78_m3_impos_eq","mtic_g78_m3_impos_eq_pt2","mtic_g78_m3_represent_eq","mtic_g78_m3_geo_perim","mtic_g78_m3_geo_area","mtic_g78_m3_word_prob","mtic_g78_m3_word_prob_pt2","mtic_g78_m3_equal_area","mtic_g78_m3_alice_bob","mtic_g78_m3_open","mtic_g78_m3_receipt"
    ]
  },
  LOGGING_OVERRIDE: {
    RESOURCE: location.search.indexOf('debugItems')> -1,
    GENERAL: location.search.indexOf('debugLogs') > -1
  },
  BROWSER_SUPPORT: {
    OVERRIDE: 'debugBrowsers',
    IS_SUPPORTED: function(){
      if(location.search.indexOf(this.OVERRIDE) > -1){
        return true;
      }else{
        var isSupported =
        (
          bowser.name === 'Chrome'
        ) ||
        (
          bowser.ipad
        );
        isSupported = isSupported && (
          !(bowser.mobile || bowser.tablet)
        );
        return isSupported;
      }
    }
  }
})
